module.exports = __webpack_public_path__ + "media/I Will Spend My Whole Life Loving You - Kina Grannis & Imaginary Future.94858503.mp3";